import { useEffect } from 'react';
import { useQuizz } from './quizz.hook';
import QuestionForm from '@/components/Views/QuestionForm/QuestionForm';
import { Button } from '@/components/Common';

const QuizzForm = () => {
  const {
    QuizzQuestionType,
    register,
    registerUpdate,
    errors,
    updateErrors,
    handleSubmit,
    handleSubmitUpdate,
    createSingleQuestion,
    setValue,
    setUpdateValue,
    handleSelectedType,
    selectedType,
    response1Check,
    setResponse1Check,
    response2Check,
    setResponse2Check,
    response3Check,
    setResponse3Check,
    response4Check,
    setResponse4Check,
    loadingQuizzCreation,
    loadingQuizzUpdate,
    formMode,
    setFormMode,
    selectedQuizz,
    updateSingleQuestion,
    resetUpdate,
    setInitialSelectedOptions,
  } = useQuizz();

  const isUpdate = formMode === 'update';

  useEffect(() => {
    const res1 = selectedQuizz?.responses[0]?.isRight as boolean;
    const res2 = selectedQuizz?.responses[1]?.isRight as boolean;
    const res3 = selectedQuizz?.responses[2]?.isRight as boolean;
    const res4 = selectedQuizz?.responses[3]?.isRight as boolean;

    if (formMode === 'update') {
      setUpdateValue('name', selectedQuizz?.name ?? undefined);
      setUpdateValue('reponse1', selectedQuizz?.responses[0]?.response);
      setUpdateValue('reponse2', selectedQuizz?.responses[1]?.response);
      setUpdateValue('reponse3', selectedQuizz?.responses[2]?.response);
      setUpdateValue('reponse4', selectedQuizz?.responses[3]?.response);
      setUpdateValue('description', selectedQuizz?.description ?? '');
      setResponse1Check(res1);
      setResponse2Check(res2);
      setResponse3Check(res3);
      setResponse4Check(res4);
    } else {
      setValue('reponse1', '');
      setValue('reponse2', '');
      setValue('reponse3', '');
      setValue('reponse4', '');
    }
  }, [
    formMode,
    selectedQuizz,
    selectedQuizz?.description,
    selectedQuizz?.name,
    selectedQuizz?.responses,
    setResponse1Check,
    setResponse2Check,
    setResponse3Check,
    setResponse4Check,
    setUpdateValue,
    setValue,
  ]);

  const RenderEditButtons = () => {
    return (
      <div className="flex items-center gap-2 w-full">
        <Button
          type="button"
          onClick={() => {
            resetUpdate();
            setFormMode('create');
            setResponse1Check(false);
            setResponse2Check(false);
            setResponse3Check(false);
            setResponse4Check(false);
            setInitialSelectedOptions && setInitialSelectedOptions(null);
          }}
          title="Annuler"
          className="mt-3 w-full  !bg-completed hover:!outline-complete hover:!text-completed hover:!bg-hoverColor  text-white !px-2"
        />
        <Button
          type="submit"
          title={`${loadingQuizzUpdate ? 'Modification...' : 'Modifier'}`}
          className="mt-3 w-full !px-2"
        />
      </div>
    );
  };

  return (
    <QuestionForm
      QuizzQuestionType={QuizzQuestionType}
      register={isUpdate ? registerUpdate : register}
      errors={isUpdate ? updateErrors : errors}
      handleSubmit={isUpdate ? handleSubmitUpdate : handleSubmit}
      onSubmit={isUpdate ? updateSingleQuestion : createSingleQuestion}
      setValue={isUpdate ? setUpdateValue : setValue}
      handleSelectedType={handleSelectedType}
      selectedType={selectedType}
      response1Check={response1Check}
      setResponse1Check={setResponse1Check}
      response2Check={response2Check}
      setResponse2Check={setResponse2Check}
      response3Check={response3Check}
      setResponse3Check={setResponse3Check}
      response4Check={response4Check}
      setResponse4Check={setResponse4Check}
      loading={loadingQuizzCreation}
      initialSelectedOptions={
        isUpdate ? { _id: 1, name: selectedQuizz?.type } : null
      }
      isEditable={isUpdate ? true : false}
      editButtons={<RenderEditButtons />}
    />
  );
};

export default QuizzForm;
